// capped by the viewport so the dialog itself never scrolls on small screens; 320px = header, stepper, footer, margins
export const STATUS_MAIL_DIALOG_HEIGHT = {
    CANCEL: 'h-[min(579px,calc(100dvh-320px))] min-h-[360px]',
    SUBSTATUS: 'h-[min(603px,calc(100dvh-320px))] min-h-[360px]',
} as const;
